import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  RESET_PO_LINES
} from '../types';

// export const purchaseOrderAddLineRequested = () => {
//   return {
//     type: PURCHASE_ORDER_ADD_LINE_REQUESTED
//   }
// };

// export const purchaseOrderAddLineSuccess = (purchaseOrderLine) => {
//   return {
//     type: PURCHASE_ORDER_ADD_LINE_SUCCESS,
//     purchaseOrderLine: purchaseOrderLine
//   }
// };

// export const purchaseOrderAddLineFailure = () => {
//   return {
//     type: PURCHASE_ORDER_ADD_LINE_FAILURE
//   }
// };


// export const purchaseOrderAddItem = (signedPayload, purchaseOrderId, itemData, itemMetadata) => {
//   return (dispatch) => {
//     dispatch(purchaseOrderAddLineRequested());

//     let endPoint = Config.baseUrl + Config.purchaseOrder;
//     let headers = Object.assign(Config.headers);
//     headers.payload = signedPayload;

//     return Axios.post(endPoint, { purchaseOrderData: purchaseOrderData, purchaseOrderLineData: purchaseOrderLineData }, { headers: headers })
//       .then((response) => {
//         dispatch(purchaseOrderAddLineSuccess(response.data));
//       })
//       .catch((error) => {
//         dispatch(purchaseOrderAddLineFailure());
//       });
//   }
// }

export const clearLines = () => {
  return {
    type: RESET_PO_LINES
  }
}


export const reset = () => {
  return (dispatch) => {
    dispatch(clearLines());
  }
}